module.exports = __webpack_public_path__ + "static/media/logov2-toolbar.604e0adb.png";